import { Button } from '@/components/ui/button';
import heroImage from '@/assets/yomi_akande.webp';
import {
  FaEnvelope,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
  FaYoutube
} from 'react-icons/fa6';

const HeroSection = () => {
  return (
    <section className='relative min-h-screen flex items-center justify-center overflow-hidden'>
      {/* Animated Background Elements */}
      <div className='absolute inset-0 overflow-hidden'>
        <div className='absolute top-1/4 left-1/4 w-72 h-72 bg-primary/10 rounded-full blur-3xl animate-float'></div>
        <div
          className='absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-float'
          style={{ animationDelay: '1s' }}
        ></div>
      </div>

      <div className='container mx-auto px-4 lg:px-8 relative z-10'>
        <div className='grid lg:grid-cols-2 gap-12 lg:gap-16 items-center'>
          {/* Content */}
          <div className='order-2 lg:order-1 flex flex-col z-10'>
            <div className='flex items-center gap-3 mb-6 justify-center md:justify-start animate-fade-up' style={{ animationDelay: '0.1s' }}>
              <div className='h-px w-10 bg-primary/60'></div>
              <span className='tracking-widest uppercase text-primary font-medium text-sm font-mono'>
                CTO & Engineering Leader
              </span>
              <div className='h-px w-10 bg-primary/60 md:hidden'></div>
            </div>

            <h1 className='text-5xl lg:text-7xl xl:text-8xl font-bold leading-tight mb-4 text-center md:text-left tracking-tighter animate-fade-up' style={{ animationDelay: '0.2s' }}>
              Yomi Akande
            </h1>

            <h2 className='text-xl lg:text-2xl font-semibold mb-6 text-center md:text-left text-primary/90 animate-fade-up' style={{ animationDelay: '0.3s' }}>
              Building Scalable FinTech Infrastructure
            </h2>

            <p className='mb-8 leading-relaxed max-w-lg text-muted-foreground text-center md:text-left text-lg animate-fade-up' style={{ animationDelay: '0.4s' }}>
              Architecting resilient distributed systems and robust
              microservices. With over 8 years of experience scaling financial
              platforms, integrating strict AML/KYC governance, and leading
              engineering teams to deliver high-throughput, secure technology
              solutions.
            </p>

            <div className='flex flex-wrap gap-2 justify-center md:justify-start mb-8'>
              {['Distributed Systems', 'Microservices', 'FinTech Architecture', 'Compliance'].map((tag, index) => (
                <span 
                  key={tag} 
                  className='px-4 py-1.5 bg-primary/10 border border-primary/20 text-primary text-xs rounded-full font-mono font-medium backdrop-blur-sm animate-fade-up'
                  style={{ animationDelay: `${0.5 + index * 0.1}s` }}
                >
                  {tag}
                </span>
              ))}
            </div>

            {/* Socials */}
            <div className='flex mb-8 space-x-4 justify-center md:justify-start animate-fade-up' style={{ animationDelay: '0.9s' }}>
              <a
                href='https://www.linkedin.com/in/yomiakande/'
                target='_blank'
                className='social-icons bg-background backdrop-blur-sm'
                rel='noopener noreferrer'
                aria-label='Yomi Akande LinkedIn Profile'
              >
                <FaLinkedinIn />
              </a>
              <a
                href='https://x.com/IamYomiAkande'
                target='_blank'
                className='social-icons bg-background backdrop-blur-sm'
                rel='noopener noreferrer'
                aria-label='Yomi Akande X Profile'
              >
                <FaXTwitter />
              </a>
              <a
                href='#'
                target='_blank'
                className='social-icons bg-background backdrop-blur-sm'
                rel='noopener noreferrer'
                aria-label='Yomi Akande YouTube Channel'
              >
                <FaYoutube />
              </a>
              <a
                href='https://www.instagram.com/IamYomiAkande/'
                target='_blank'
                className='social-icons bg-background backdrop-blur-sm'
                rel='noopener noreferrer'
                aria-label='Yomi Akande Instagram Profile'
              >
                <FaInstagram />
              </a>
              <a
                href='mailto:hello@yomiakande.com'
                className='social-icons bg-background backdrop-blur-sm'
                rel='noopener noreferrer'
                aria-label='Send an email Yomi Akande'
              >
                <FaEnvelope />
              </a>
            </div>

            <div className='flex flex-col sm:flex-row gap-4 animate-fade-up' style={{ animationDelay: '1.0s' }}>
              <Button
                size='lg'
                className='group bg-primary text-primary-foreground hover:bg-primary/90'
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Work With Me
              </Button>
              <Button
                variant='outline'
                size='lg'
                className='group border-primary/50 text-primary hover:bg-primary/10'
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Book me to Speak
              </Button>
            </div>
          </div>

          {/* Image */}
          <div
            className='order-1 lg:order-2 animate-fade-up-slow relative h-full flex justify-center lg:justify-end'
            style={{ animationDelay: '0.6s' }}
          >
            <div className='hero-image overflow-hidden'>
              <img
                src={heroImage}
                alt='Yomi Akande - CTO & FinTech Architect'
                className='w-full h-full object-cover'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
